import { useModalManager } from './useModalManager';

export function useModalManagerInertness(id?: string) {
  const { hasActiveModal, isActiveModal } = useModalManager(id!);

  const isInert: boolean = (!id && hasActiveModal) || (!!id && !isActiveModal);

  return {
    isInert,
    inertProps: {
      /**
       * For React 18 (string, not boolean)
       * @see https://stackoverflow.com/questions/72720469/error-when-using-inert-attribute-with-typescript/77153892#77153892
       */
      inert: (isInert ? '' : undefined) as boolean | undefined
    }
  };
}
